export default {
  types: {
    work: "Произведение",
    expression: "Выражение",
    manifestation: "Издание",
    item: "Экземпляр",
    person: "Лицо",
    collective_agent: "Коллективный агент",
    nomen: "Номен",
    place: "Место",
    concept: "Понятие",
    prize: "Премия",
    prize_season: "Сезон премии",
  },
  typesPlural: {
    work: "Произведения",
    expression: "Выражения",
    manifestation: "Издания",
    item: "Экземпляры",
    person: "Лица",
    collective_agent: "Коллективные агенты",
    nomen: "Номены",
    place: "Места",
    concept: "Понятия",
    prize: "Премии",
    prize_season: "Сезоны премий",
  },
  unionMember: "Член Союза писателей",
  tabs: {
    description: "Описание",
    relations: "Связи",
    marc: "MARC",
    export: "Экспорт / цитирование",
    report: "Сообщить об ошибке",
  },
  attributes: "Атрибуты",
  attr: {
    title: "Заглавие",
    subtitle: "Подзаголовок",
    responsibility: "Сведения об ответственности",
    edition: "Сведения об издании",
    publication_place: "Место издания",
    publisher_name: "Издательство",
    publication_year: "Год издания",
    extent: "Объём",
    illustrative_content: "Иллюстрации",
    dimensions: "Размер",
    print_run: "Тираж",
    manufacturer_name: "Типография",
    series_title: "Серия",
    series_number: "Номер в серии",
    age_rating: "Возрастная маркировка",
    annotation: "Аннотация",
    language: "Язык",
    form: "Форма",
    original_language: "Язык оригинала",
    date_created: "Дата создания",
    content_type: "Тип содержания",
    isbn: "ISBN",
    holding_library: "Библиотека-держатель",
    collection_code: "Фонд / коллекция",
    call_number: "Шифр хранения",
    birth_date: "Дата рождения",
    death_date: "Дата смерти",
    gender: "Пол",
    birth_place: "Место рождения",
    region: "Регион",
    biography: "Биография",
    kind: "Вид",
    place: "Место",
    founded: "Год основания",
    country: "Страна",
    scheme: "Схема",
    notation: "Индекс",
    level: "Уровень",
    organizer: "Учредитель",
    note: "Комментарий",
    year: "Год / сезон",
    awarded_year: "Год вручения",
  },
  scheme: {
    isbn: "ISBN",
    issn: "ISSN",
    doi: "DOI",
    udc: "УДК",
    bbk: "ББК",
    viaf: "VIAF",
    isni: "ISNI",
    rsl_auth: "АФ РГБ",
    nlr_auth: "АФ РНБ",
    rsl_reg: "Рег. номер РГБ",
    nbr_bib: "№ записи НБР",
    rsl_bib: "№ записи РГБ",
    nlr_bib: "№ записи РНБ",
    excel_row: "Строка Excel",
  },
  nomens: "Имена и заглавия",
  identifiers: "Идентификаторы",
  permalink: "Постоянная ссылка",
  iri: "IRI",
  source: "Источник",
  updated: "Обновлено",
  relationsEmpty: "Связи не указаны.",
  incoming: "Входящие",
  outgoing: "Исходящие",
  recommendations: "Похожие записи",
  marcLeader: "Лидер",
  marcEmpty: "MARC-запись недоступна.",
  citation: "Библиографическая ссылка",
  citationStyle: "Стиль",
  exportFormat: "Формат экспорта",
  exportAction: "Скачать файл",
  reportMessage: "Описание ошибки",
  reportField: "Поле (необязательно)",
  reportEmail: "Контактный email",
  reportSent: "Сообщение отправлено. Спасибо!",
  notFound: "Запись не найдена",
  addToCollection: "В коллекцию",
  pickCollection: "Выберите коллекцию",
  dossierWork: "Произведение",
  dossierWorks: "Произведения",
  dossierEdition: "Это издание",
  dossierEditions: "Издания",
  dossierOtherEditions: "Другие издания",
  dossierCreators: "Авторы и участники",
  dossierSubjects: "Темы",
  dossierPrizes: "Премии",
  dossierNominees: "Номинанты",
  dossierPublishers: "Издательство",
  dossierOther: "Ещё связи",
  dossierMore: "MARC, экспорт и сообщение об ошибке",
  graphTitle: "Связи записи",
  graphHint: "Нажмите на узел, чтобы раскрыть его связи",
  graphExpanding: "Загрузка связей…",
  graphExpandEmpty: "Дальше связей нет.",
  graphExpandError: "Не удалось загрузить связи.",
  graphPath: "Путь по связям",
  graphHome: "В начало",
  graphCentered: "Центр: {{label}}",
  graphShownOf: "Показано {{shown}} из {{total}}",
  graphOpen: "Открыть карточку",
  graphMore: "Ещё связей: {{count}}",
}
